import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import IBuildingZoningAllowance = ZoningAPI.IBuildingZoningAllowance;
import { zoningAllowanceDictionary } from '../../../../../shared/models';

@Component({
    standalone: false,
    selector: 'app-calc-params',
    templateUrl: './calculation-parameters.component.html',
    styleUrls: ['./calculation-parameters.component.scss']
})
export class CalculationParametersInfoComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: IBuildingZoningAllowance) {}

    zoningAllowanceDictionary: object = zoningAllowanceDictionary;
}
